import { maxWidth600 } from "themes/default/breakpoints"

export const styles = {
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    mb: 1,
    flexWrap: "wrap",
    width: "100%",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    flexWrap: "wrap",
    gap: 0.5,
  },
  title: (theme) => ({
    color: theme.palette.text.primary,
  }),
  titleSeparator: (theme) => ({
    color: theme.palette.text.secondary,
  }),
  stepTitle: (theme) => ({
    color: theme.palette.primary.blueBright,
    mt: 0.5,
  }),
  pageSubtitle: (theme) => ({
    color: theme.palette.text.secondary,
    mt: 0.5,
  }),
  sparkIcon: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: 22,
    verticalAlign: "text-top",
    ml: 0.5,
  }),
  rightContent: {
    flexShrink: 0,
    [maxWidth600]: {
      width: "100%",
    },
  },
  stepperWrapper: {
    flexShrink: 0,
  },
}
